<h2 mat-dialog-title *ngIf="data.showTitle">{{data.title}}</h2>
<mat-dialog-content>
  <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: end !important;">
  <button *ngIf="data.isConfirm" mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
